import { Linking, Platform, Share } from 'react-native';
import { semBloqueio } from './ausencia';
import type { Anexo } from '../store/types';

// 0.58: proteção contra links e anexos maliciosos vindos de outras pessoas (fichas compartilhadas, grupos, publicações).

const limpar = (u: unknown) => String(u ?? '').replace(/[\u0000- \u007f-\u009f]/g, '');
const ESQUEMA = /^[a-z][a-z0-9+.-]*:/i;
// No navegador só abre o que é seguro; no celular só bloqueia o que roda código ou lê arquivo do aparelho.
const OK_WEB = /^(https?:|mailto:|tel:|sms:|blob:|myplanner:|whatsapp:)/i;
const PERIGOSO = /^(javascript:|vbscript:|data:|file:)/i;

/** true se o endereço pode ser aberto (endereço relativo, http/https, e-mail, telefone...). */
export function linkSeguro(u: unknown): boolean {
  const s = limpar(u);
  if (!s || s === 'about:blank' || !ESQUEMA.test(s)) return true;
  return Platform.OS === 'web' ? OK_WEB.test(s) : !PERIGOSO.test(s);
}

export const urlHttp = (u: unknown) => /^https?:\/\//i.test(limpar(u));
const DADO_OK = /^data:[a-z0-9.+\/-]+(;[a-z0-9=.-]+)*;base64,[A-Za-z0-9+/=]+$/i;
export const IMAGEM_DADO = /^data:image\/(png|jpe?g|gif|webp);base64,[A-Za-z0-9+/=]+$/i;

/** Anexo recebido de outra pessoa: tira link que não seja http(s) e conteúdo embutido fora do formato esperado. */
export function anexoSeguro(a: any): Anexo | null {
  if (!a || typeof a !== 'object' || typeof a.nome !== 'string') return null;
  const o: any = { ...a, nome: a.nome.slice(0, 200) };
  if (o.url != null && !urlHttp(o.url)) delete o.url;
  if (o.dado != null && (typeof o.dado !== 'string' || !DADO_OK.test(o.dado))) delete o.dado;
  if (o.mime != null && (typeof o.mime !== 'string' || !/^[a-z0-9.+\/-]{1,100}$/i.test(o.mime))) delete o.mime;
  return o as Anexo;
}

let ligado = false;
/** Liga a proteção uma vez ao abrir o app: qualquer abertura de link passa pela conferência. */
export function protegerLinks() {
  if (ligado) return; ligado = true;
  const original = Linking.openURL.bind(Linking);
  // 0.66 (A3): abrir um link/app pelo próprio app não conta como sair do app (não pede a senha na volta)
  (Linking as any).openURL = (u: string) => (linkSeguro(u) ? semBloqueio(() => original(u)) : Promise.reject(new Error('Link bloqueado por segurança.')));
  const compartilhar = Share.share.bind(Share);
  (Share as any).share = (...a: Parameters<typeof Share.share>) => semBloqueio(() => compartilhar(...a));
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    const abrir = window.open.bind(window);
    window.open = ((u?: string | URL, ...r: any[]) => (linkSeguro(u) ? abrir(u as any, ...r) : null)) as typeof window.open;
  }
}
